// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-administrator-side-bar{
        height: 100%;
        z-index: 0;
        width: 10vw;
        padding-top: 20px;
        box-sizing: border-box;
        background-color: rgba(155, 30, 30, 0.952);
        display: block;
    }
    .customer-administrator-side-bar-button-container{
        display: block;
        color: transparent;
        background-color: transparent;
        text-align: left;
        padding-left: 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .customer-administrator-side-bar-button-container img{
        height: 25px;
    }
    .customer-administrator-side-bar-button-container button{
        border: none;
        margin-left: 2px;
        padding: 10px 5px;
        font-size: 16px;
        cursor: inherit;
        color: white;
        background-color: transparent;
    }
}
@media screen and (max-width:949px){
    .customer-administrator-side-bar{
        position: absolute;
        z-index: 1;
        width: 60vw;
        height: 100%;
        background-color: rgba(155, 30, 30, 0.952);
        display: none;
    }
    .customer-administrator-side-bar.show{
        display: block;
    }
    .customer-administrator-side-bar-button-container{
        display: block;
        color: transparent;
        background-color: transparent;
        text-align: left;
        padding-left: 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .customer-administrator-side-bar-button-container img{
        height: 25px;
    }
    .customer-administrator-side-bar-button-container button{
        border: none;
        margin-left: 2px;
        padding: 10px 5px;
        font-size: 16px;
        cursor: inherit;
        color: white;
        background-color: transparent;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar_styles/CustomerAdministratorSideBar.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,UAAU;QACV,WAAW;QACX,iBAAiB;QACjB,sBAAsB;QACtB,0CAA0C;QAC1C,cAAc;IAClB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,6BAA6B;QAC7B,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,eAAe;QACf,YAAY;QACZ,6BAA6B;IACjC;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,0CAA0C;QAC1C,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,6BAA6B;QAC7B,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,eAAe;QACf,YAAY;QACZ,6BAA6B;IACjC;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-administrator-side-bar{\r\n        height: 100%;\r\n        z-index: 0;\r\n        width: 10vw;\r\n        padding-top: 20px;\r\n        box-sizing: border-box;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        display: block;\r\n    }\r\n    .customer-administrator-side-bar-button-container{\r\n        display: block;\r\n        color: transparent;\r\n        background-color: transparent;\r\n        text-align: left;\r\n        padding-left: 18px;\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-administrator-side-bar-button-container img{\r\n        height: 25px;\r\n    }\r\n    .customer-administrator-side-bar-button-container button{\r\n        border: none;\r\n        margin-left: 2px;\r\n        padding: 10px 5px;\r\n        font-size: 16px;\r\n        cursor: inherit;\r\n        color: white;\r\n        background-color: transparent;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-administrator-side-bar{\r\n        position: absolute;\r\n        z-index: 1;\r\n        width: 60vw;\r\n        height: 100%;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        display: none;\r\n    }\r\n    .customer-administrator-side-bar.show{\r\n        display: block;\r\n    }\r\n    .customer-administrator-side-bar-button-container{\r\n        display: block;\r\n        color: transparent;\r\n        background-color: transparent;\r\n        text-align: left;\r\n        padding-left: 18px;\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-administrator-side-bar-button-container img{\r\n        height: 25px;\r\n    }\r\n    .customer-administrator-side-bar-button-container button{\r\n        border: none;\r\n        margin-left: 2px;\r\n        padding: 10px 5px;\r\n        font-size: 16px;\r\n        cursor: inherit;\r\n        color: white;\r\n        background-color: transparent;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
